import lozad from "lozad";

export default () => {
  const observer = lozad(".lozad", {
    rootMargin: "5%"
  });
  observer.observe();
};
